/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CourseType {
    IN_PERSON = 'InPerson',
    ONLINE = 'Online',
}
